export const BASE_THEME_NAME = 'base';
